/**
 * usePageLoader Composable
 *
 * Global page-loading indicator (NProgress-style). A shared reactive state
 * that the router guards start/stop and BasePageLoader renders as a
 * top-of-page animated bar.
 */

import { ref, computed } from 'vue'

// Shared singleton state
const loading = ref(false)

export function usePageLoader() {
  const isLoading = computed(() => loading.value)

  function start() {
    loading.value = true
  }

  function stop() {
    // Small delay so the bar finishes its animation before hiding
    setTimeout(() => {
      loading.value = false
    }, 350)
  }

  return {
    isLoading,
    start,
    stop
  }
}
